import { useEffect, useState, useMemo } from 'preact/hooks';
import { store } from './sync/engine';
import { buildBooks } from './lib/model';
import { coverRunner, type RunState } from './lib/coverRunner';

// Re-randează componenta la orice schimbare din store (sync, operații locale)
export function useStore() {
  const [, setV] = useState(store.version);
  useEffect(() => store.subscribe(() => setV(store.version)), []);
  return store;
}

export function useBooks() {
  const s = useStore();
  return useMemo(() => buildBooks(s.view, s.me), [s.version]);
}

export function useCoverRunner(): RunState {
  const [st, setSt] = useState(coverRunner.state);
  useEffect(() => coverRunner.subscribe(() => setSt(coverRunner.state)), []);
  return st;
}
